module.exports = __webpack_public_path__ + "static/media/logo-togo.a6ba8907.png";